module.exports = __webpack_public_path__ + "static/img/财务共享中心的AI风控审核方案_架构图.f6cdb1b0.png";